import React, { useEffect,useState } from "react";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { useSelector, useDispatch } from "react-redux";
import UiSlider from "../../../_uiComponents/common/UiSlider";
import UiDbSliderCard from "../../../_uiComponents/common/cards/UiDbSliderCard";
import { InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";
import { showCustomLoading } from "../../../../_helpers/support.services";
import { dashboardConstants } from "../../../../_redux/_constants";
import { getParticipantsSliderCardDownloadRequest } from "../../../../_redux/_actions";

export default function StatisticCarousel(props) {
     const actionDispatch = useDispatch();
     const [exportParticipantsData, setExportParticipantsData] = useState(null); 
     const [exportLocationData, setExportLocationData] = useState(null); 

     const { dashBoardSummary, loader, dashboardParticipantsSliderCardDownload,dashboardLocationSliderCardDownload } = useSelector((state) => {
          return {
               dashBoardSummary: state.dashboard.dashboardSummary,
               loader: state.loading,
               dashboardLocationSliderCardDownload:state.dashboard.dashboardLocationSliderCardDownload,
               dashboardParticipantsSliderCardDownload:state.dashboard.dashboardParticipantsSliderCardDownload
          };
     });

     useEffect(function () {
          props.getData();
     }, []);


     useEffect(()=>{
          setExportParticipantsData(dashboardParticipantsSliderCardDownload)
     },[dashboardParticipantsSliderCardDownload])

     useEffect(()=>{
            //console.log(dashboardLocationSliderCardDownload)
     },[dashboardLocationSliderCardDownload])

     const handleExport = (onDownloadComplete) => {
           try {
               actionDispatch(getParticipantsSliderCardDownloadRequest({
                         downloadType:"participants",
                         applicationId: props.applicationId
                    }));
          } catch (error) {
               onDownloadComplete(false);
               console.error("Error fetching data for export:", error);
          }       
     };

     return (
          <>
               {showCustomLoading(
                    [dashboardConstants.DASHBOARD_GET_DASHBOARD_SUMMARY_REQUEST],
                    loader.pendingRequests
               ) && <InnerLoader/>}
               <div className="sba-chart-section-top">
                    <div className="sba-drag-handle">
                         <DehazeIcon />
                    </div>
               </div>

               <div>
                    <UiSlider slidesToShow={1} variableWidth ={true} infinite={true}>
                         <div>
                              {props.applicationId == 0 && (
                                   <UiDbSliderCard
                                        title="Participants"
                                        columnOneAmount={
                                             dashBoardSummary?.totalParticipants
                                        }
                                        columnOne="Total Participant"
                                        columnTwoAmount={
                                             dashBoardSummary?.totalAreaManagers
                                        }
                                        columnTwo="Area Managers"
                                        columnThreeAmount={
                                             dashBoardSummary?.totalServiceManagers
                                        }
                                        columnThree="Service Managers"
                                        columnFourAmount={
                                             dashBoardSummary?.totalServiceAdvisors
                                        }
                                        columnFour="Service Advisors"
                                        columnFiveAmount={
                                             dashBoardSummary?.totalCustomers
                                        }
                                        columnFive="Total Customers"

                                        columnSixAmount={
                                             dashBoardSummary?.totalTradeAreaManagers
                                        }
                                        columnSix="Total Trade Area Managers"
                                        // exportInfo={{
                                        //      name: "Participants Export",
                                        //      data: exportParticipantsData, 
                                        //      fetchDataForExport: handleExport
                                        // }}
                                   />
                              )}

                              {props.applicationId == 1 && (
                                   <UiDbSliderCard
                                        title="Participants"
                                        columnOneAmount={
                                             dashBoardSummary?.totalParticipants
                                        }
                                        columnOne="Total Participant"
                                        columnTwoAmount={
                                             dashBoardSummary?.totalAreaManagers
                                        }
                                        columnTwo="Area Managers"
                                        columnThreeAmount={
                                             dashBoardSummary?.totalServiceManagers
                                        }
                                        columnThree="Service Managers"
                                        columnFourAmount={
                                             dashBoardSummary?.totalServiceAdvisors
                                        }
                                        columnFour="Service Advisors"
                                   />
                              )}

                              {props.applicationId == 3 && (
                                   <UiDbSliderCard
                                        title="Participants"
                                        columnOneAmount={
                                             dashBoardSummary?.totalCustomers
                                        }
                                        columnOne="Total Customers"
                                        columnTwoAmount={
                                             dashBoardSummary?.totalTradeAreaManagers
                                        }
                                        columnTwo="Total Trade Area Managers"
                                   />
                              )}
                         </div>
                         <div>
                              <UiDbSliderCard
                                   title="Locations"
                                   columnOneAmount={
                                        dashBoardSummary?.totalAreas
                                   }
                                   columnOne="Total Areas"
                                   columnTwoAmount={
                                        dashBoardSummary?.totalLocations
                                   }
                                   columnTwo="Total Locations"
                                   columnThreeAmount={
                                        dashBoardSummary?.totalDealers
                                   }
                                   columnThree="Total Dealers"
                              />
                         </div>

                         <div className="sba-campaign-reward-issue">
                              <UiDbSliderCard
                                   title="Campaign Rewards Issued"
                                   columnOne=""
                                   columnOneAmount={
                                        dashBoardSummary?.totalRewardPoints
                                   }
                              />
                         </div>
                         <div>
                              <UiDbSliderCard
                                   title="Campaigns"
                                   columnOneAmount={
                                        dashBoardSummary?.scheduledCampaigns
                                   }
                                   columnOne="Scheduled"
                                   columnTwoAmount={
                                        dashBoardSummary?.activeCampaigns
                                   }
                                   columnTwo="Active"
                                   columnThreeAmount={
                                        dashBoardSummary?.closedCampaigns
                                   }
                                   columnThree="Closed"
                              />
                         </div>
                    </UiSlider>
               </div>
          </>
     );
}
